<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>经营者信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">经营者信息</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="认证时间">
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="ruleForm.time"
                      type="datetime"
                      placeholder="选择开始时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                    <div style="margin: 0 5px">-</div>
                    <el-date-picker
                      v-model="ruleForm.time1"
                      type="datetime"
                      placeholder="选择结束时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="年份">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.year"
                      placeholder="选择年份"
                      style="margin-right: auto"
                    >
                      <el-option label="2025年" value="2025"></el-option>
                      <el-option label="2026年" value="2026"></el-option>
                      <el-option label="2027年" value="2027"></el-option>
                      <el-option label="2028年" value="2028"></el-option>
                      <el-option label="2029年" value="2029"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="季度">
                  <div style="display: flex; align-items: center">
                    <el-select
                      v-model="ruleForm.season"
                      placeholder="选择季度"
                      style="margin-right: auto"
                    >
                      <el-option label="Q1" value="1"></el-option>
                      <el-option label="Q2" value="2"></el-option>
                      <el-option label="Q3" value="3"></el-option>
                      <el-option label="Q4" value="4"></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待申报" value="0"></el-option>
                    <el-option label="已申报" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div style="margin-bottom: 20px">
          <el-button type="primary" @click="InvoicingAll()" class="btn"
            >批量申报</el-button
          >
          <el-button type="primary" @click="dowon()" class="btn"
            >税务申报模板下载</el-button
          >
          <el-button type="primary" @click="exportList(2)" class="btn"
            >导出申报excel</el-button
          >
        </div>
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column
            prop="hasRegisterCert"
            label="是否已取得等级证照"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="姓名"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="licenseNo"
            label="统一社会信用代码"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="professionSeverOrgan"
            label="专业服务机构标识"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="unRegisterName"
            label="未取得登记证-姓名"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="certTypeName" label="证件类型" align="center">
          </el-table-column>
          <el-table-column prop="certCode" label="证件号码" align="center">
          </el-table-column>
          <el-table-column prop="adcode" label="国家或地区编号" align="center">
          </el-table-column>
          <el-table-column
            prop="hasPush"
            label="是否存在免于报送收入信息情形"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column prop="noReportType" label="免报类型" align="center">
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="center"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="店铺(用户)名称"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="店铺(用户)唯一标识码"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="url" label="网址地址" align="center">
          </el-table-column>
          <el-table-column
            prop="bank"
            label="开户银行/非银行支付机构"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column prop="billDetailNo" label="账户名称" align="center">
          </el-table-column>
          <el-table-column
            prop="billDetailNo"
            label="银行账号/支付账号"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="corporateName"
            label="联系人名称"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系人电话"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="startAt"
            label="经营开始时间"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="endAt"
            label="经营结束时间"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="recordStatus"
            label="信息状态标识"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.isDeclare == 0"
                >未申报</span
              >
              <span class="greenColor" v-if="scope.row.isDeclare == 1"
                >已申报</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround" v-if="scope.row.isDeclare == 0">
                <div class="operateBtn" @click="Invoicing(scope.row)">
                  提交申报
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose1"
    >
      <div style="height: 350px; overflow-y: scroll">
        <div v-for="(item, index) in errorList" :key="index">{{ item }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taxData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        year: "",
        season: "",
        time: "",
        time1: "",
      },
      tableData: [],
      errorList: [],
      page: 1,
      pageSize: 20,
      total: 0,
      multipleTable: [],
      failDesc: "",
      dialogVisible1: false,
      selectData: {},
      status: "",
      type: "0", //0 单独数据处理   1批量数据确认
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    dowon() {
      window.open(
        "http://down.baoanlailou.com/file/excel/template平台内的经营者和从业人员身份信息报送表-咖德.xls"
      );
    },
    handleClose() {
      this.dialogVisible = false;
      this.status = "";
      this.failDesc = "";
    },
    handleClose1() {
      this.dialogVisible1 = false;
    },
    exportList(key) {
      let arr = [];
      if (this.multipleTable.length != 0) {
        for (var i = 0; i < this.multipleTable.length; i++) {
          arr.push(this.multipleTable[i].id);
        }
      }
      if (this.ruleForm.season == "") {
        this.$message({
          message: "请选择季度",
          type: "warning",
        });
        return;
      }
      if (this.ruleForm.year == "") {
        this.$message({
          message: "请选择年度",
          type: "warning",
        });
        return;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        isDeclare: this.ruleForm.status,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        season: this.ruleForm.season,
        year: this.ruleForm.year,
        ids: arr,
      };
      this.$axios
        .post("/admapi/tax/manager/export", param, { responseType: "blob" })
        .then((data) => {
          console.log(data);
          this.$refs.multipleTable.clearSelection();
          let val = new Blob([data.data], {
            type: "application/vnd.ms-excel;charset=utf-8",
          });
          let header = decodeURI(data.headers["content-disposition"]);
          // console.log(header);
          let index = header.indexOf("''");
          let fileName = header.substring(index + 2, header.length);
          console.log(fileName);
          const url = window.URL.createObjectURL(val);
          const link = document.createElement("a");
          link.download = fileName; // 设置a标签的下载属性
          link.style.display = "none";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href); // 下载完成释放URL 对象
          document.body.removeChild(link);
        })
        .catch()
        .finally();
      // );
    },
    InvoicingAll() {
      this.$confirm("是否批量提交申报", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.multipleTable.length == 0) {
            this.$message({
              message: "请选择确认数据",
              type: "warning",
            });
            return;
          }
          let arr = [];
          for (var i = 0; i < this.multipleTable.length; i++) {
            arr.push(this.multipleTable[i].id);
          }
          let param = {
            ids: arr,
            state: this.status,
            failDesc: this.failDesc,
          };
          this.$axios
            .post(`/admapi/tax/manager/taxer/batchsubmit`, param)
            .then(({ data }) => {
              this.$message({
                message: "批量申报成功",
                type: "success",
              });
              this.multipleTable = [];
              this.$refs.multipleTable.clearSelection();
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    Invoicing(val) {
      this.selectData = val;
      this.$confirm("是否确认提交申报", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: this.selectData.id,
            state: this.status,
            failDesc: this.failDesc,
          };
          this.$axios
            .post(`/admapi/tax/manager/taxer/submit`, param)
            .then(({ data }) => {
              this.$message({
                message: "申报成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.phone = "";
      this.ruleForm.season = "";
      this.ruleForm.year = "";
      this.ruleForm.id = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        phone: this.ruleForm.phone,
        isDeclare: this.ruleForm.status,
        startTime: this.ruleForm.time,
        endTime: this.ruleForm.time1,
        season: this.ruleForm.season,
        year: this.ruleForm.year,
      };
      this.$axios
        .post(`/admapi/tax/manager/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
